import { z } from 'zod';

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export const TIME_WINDOW_OPTIONS = [
  { value: '5m', label: '5 minutes', duration: 5 * MINUTE },
  { value: '15m', label: '15 minutes', duration: 15 * MINUTE },
  { value: '30m', label: '30 minutes', duration: 30 * MINUTE },
  { value: '1h', label: '1 hour', duration: HOUR },
  { value: '3h', label: '3 hours', duration: 3 * HOUR },
  { value: '6h', label: '6 hours', duration: 6 * HOUR },
  { value: '12h', label: '12 hours', duration: 12 * HOUR },
  { value: '1d', label: '1 day', duration: DAY },
  { value: '3d', label: '3 days', duration: 3 * DAY },
  { value: '7d', label: '7 days', duration: 7 * DAY },
  { value: '14d', label: '14 days', duration: 14 * DAY },
  { value: '30d', label: '30 days', duration: 30 * DAY },
] as const;

export type TimeWindow = (typeof TIME_WINDOW_OPTIONS)[number]['value'];

const TIME_WINDOW_VALUES = TIME_WINDOW_OPTIONS.map(({ value }) => value) as [
  TimeWindow,
  ...TimeWindow[],
];

export const timeWindowSchema = z.enum(TIME_WINDOW_VALUES);

export function getCreatedAfterFromTimeWindow(
  timeWindow: TimeWindow,
  now = Date.now(),
) {
  const { duration } = TIME_WINDOW_OPTIONS.find(
    ({ value }) => value === timeWindow,
  )!;

  return new Date(now - duration).toISOString();
}
